import type {
	CreatorAgentSuccessFlowStepKey as AgentSuccessStep,
	CreatorAgentSuccessFlowVariant
} from '@newo/tenant-metadata';
import type { LucideIcon } from 'lucide-react';

export enum AgentSuccessAction {
	ACTIVATE_ACCOUNT = 'activate_account',
	NEXT_CARD = 'next_card',
	REDIRECT = 'redirect'
}

export type RedirectAction = {
	action: AgentSuccessAction.REDIRECT;
	url?: string;
};

export enum OnboardingTour {
	PORTAL = 'portal'
}

export type ActivateAccountAction = {
	action: AgentSuccessAction.ACTIVATE_ACCOUNT;
};

export type NextCardAction = {
	action: AgentSuccessAction.NEXT_CARD;
};

export enum CardType {
	SCRIPT = 'script',
	DEFAULT = 'default'
}

export type TAgentSuccessStepCard = {
	type?: CardType;
	icon?: LucideIcon;
	nextStep?: AgentSuccessStep;
	onboardingTour?: OnboardingTour;
	videoSrc?: string;
	showInfo?: boolean;
	learnMoreLink?: string;
	redirectUrl?: string;
	url?: string;
} & (RedirectAction | ActivateAccountAction | NextCardAction);

export type TAgentSuccessCards = Partial<
	Record<AgentSuccessStep, TAgentSuccessStepCard>
>;

export type TAgentSuccessConfig = {
	variant: CreatorAgentSuccessFlowVariant;
	isStepperIncluded: boolean;
	stepOrder: AgentSuccessStep[];
	steps: TAgentSuccessCards;
};

export type TAgentSuccessBaseCard = Pick<TAgentSuccessStepCard, 'action'> &
	Partial<TAgentSuccessStepCard>;
